import { ZodIssue } from 'zod';

export class ZodValidationError extends Error {
  issues?: ZodIssue[];

  constructor(message?: string, issues?: ZodIssue[]) {
    super(message);
    this.issues = issues;
  }
}
